import script from "./VSwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./VSwitch.vue?vue&type=script&lang=ts&setup=true"

import "./VSwitch.vue?vue&type=style&index=0&id=ee8233f4&lang=sass"

const __exports__ = script;

export default __exports__